module.exports = __webpack_public_path__ + "img/2.34f8f668.png";